import { arrayOf, func, shape, string } from 'prop-types'
import { Component } from 'react'

import Select from 'views/components/molecules/Select'
import { interact } from 'views/components/organisms/AlgoliaInstantSearch/Algolia/helpers'
import { i18nType } from 'views/utils/propTypes'

import './SortByDesktop.scss'

class SortByDesktop extends Component {
  render() {
    const { items, currentRefinement, refine, i18n } = this.props
    const options = items.map(option => ({
      value: option.value,
      text: option.label,
    }))

    return (
      <Select
        selectedValue={currentRefinement}
        label={i18n._('general.label.sort.Sortierung')}
        id="select_sortby"
        name="select_sortby_select"
        onChange={interact(refine)}
        className="o-SortByDesktop--select"
        options={options}
      />
    )
  }
}

SortByDesktop.propTypes = {
  items: arrayOf(shape({})).isRequired,
  refine: func.isRequired,
  i18n: i18nType.isRequired,
  currentRefinement: string,
}

SortByDesktop.defaultProps = {
  currentRefinement: null,
}

export default SortByDesktop
